// Call Recordings: labels, filters and formatting shared by the page and its parts.

export const RECORDING_STATUS = {
  pending: ['Pending', 'gold'],
  processing: ['Processing', 'gold'],
  available: ['Available', 'green'],
  failed: ['Failed', 'red'],
  expired: ['Expired', 'grey'],
  deleted: ['Deleted', 'grey'],
};

export const DURATIONS = [['', 'Any duration'], ['short', 'Under 1 min'], ['medium', '1 – 5 min'], ['long', 'Over 5 min']];

export const EMPTY_FILTERS = { direction: '', range: '', from: '', to: '', duration: '', agent: '', tag: '' };

export function formatBytes(n) {
  if (!n) return '0 MB';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(units.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
  return `${(n / 1024 ** i).toFixed(i >= 2 ? 1 : 0)} ${units[i]}`;
}

export const initials = (r) => (r.contact_name || '#').split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase();
